<template>
		<div class="list--view">            
            <div class="single--list-view single--list-view-employees">
                <vs-select
                    class="selectExample"
                    v-model="selectTypeRoles"
                    @input="statusSelected"
                >
                    <vs-select-item
                        :is-selected="item.isSelected"
                        :key="index"
                        :value="item.value"
                        :text="item.label"
                        v-for="(item,index) in optionsTypeRoles" />
                </vs-select>
            </div>
            <div class="single--list-view single--list-view-employees">
                <vs-select
                    class="selectExample"
                    v-model="selectDailyStatusType"
                    @input="statusDailySelected"
                >
                    <vs-select-item
                        :is-selected="item.isSelected"
                        :key="index"
                        :value="item.value"
                        :text="item.label"
                        v-for="(item,index) in optionsDailyStatusType" />
                </vs-select>
            </div>
        </div>
</template>

<script>
    export default {
        data () {
            return {
                selectDailyStatusType: (location.search.indexOf("status") <= 0 ? 'all' : /status=([^&]+)/.exec(location.href)[1]),
                optionsDailyStatusType:[
                    {value: 'all', label: 'All', isSelected: false },
                    {value: 'taken', label: 'Goduto', isSelected: false },
                    {value: 'planned', label: 'Pianificato', isSelected: false },
                ],
                
                selectTypeRoles: (location.search.indexOf("closed") >= 0 && /closed=([^&]+)/.exec(location.href)[1] === "true") ? "hystorical" : "actual",
                optionsTypeRoles:[                    
                    {value: 'actual', label: 'Attuali', isSelected: false },
                    {value: 'hystorical', label: 'Storico', isSelected: false },
                ],
            }
        },
        methods: {
            statusSelected(selectedOption, id) {
                if (selectedOption == "actual") {
                    location.href = app.__vue__.addParam("closed", "false");
                } else if (selectedOption == "hystorical") {
                    location.href = app.__vue__.addParam("closed", "true");
                }
            },            
            statusDailySelected(selectedOption, id) {
                if (selectedOption == "taken") {
                    location.href = app.__vue__.addParam("status", "taken");
                } else if (selectedOption == "planned") {
                    location.href = app.__vue__.addParam("status", "planned");
                } else if (selectedOption == "all") {
                    location.href = app.__vue__.addParam("status", "all");
                }
            },

        },

    }
</script>
